var Block_Slider_Video = {
    init:function(){
        var swiper = new Swiper(".block-slider-video .slider-container", {
            speed: 600,
            loop: true,
            slidesPerView: "auto",
            centeredSlides: true,
            freeMode: false,
            grabCursor: true,
            mousewheel: false,
            slideToClickedSlide: false,
            touchStartPreventDefault: false,
            preventClicks: true,
            spaceBetween:30,
        });
    }
}

$(window).load(function(){
    if($(".block-slider-video").length){
     Block_Slider_Video.init();
    }
})